import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';
import { Router } from '@angular/router';
import { AuthMSALService } from '../../core/auth/msal/auth-msal.service';

@Component({
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit {

  constructor(private auth: AuthService, private authMSALService: AuthMSALService, private router: Router) { }

  ngOnInit() {
    this.auth.clearUser();
    this.authMSALService.signOut();
    // this.router.navigate(['/']); // 
  }

}



// WEBPACK FOOTER //
// ./client/app/features/logout/logout.component.ts